export const Logo = ({ light = false, testId = "header-logo", onClick }) => (
  <a href="#home" onClick={onClick} data-testid={testId} className="group flex items-center gap-3">
    <span
      className={`grid h-12 w-12 shrink-0 place-items-center rounded-full transition-transform duration-500 ease-out group-hover:scale-110 ${
        light ? "bg-ns-ivory p-2 ring-1 ring-ns-gold/50" : "p-0.5"
      }`}
    >
      <img src="/images/logo-mark.png" alt="NutriSwaad logo" className="h-full w-full object-contain" />
    </span>
    <span className="leading-none">
      <span className="block font-sans text-[1.35rem] font-extrabold tracking-[-0.02em]">
        <span className={light ? "text-ns-ivory" : "text-[#1E6B35]"}>Nutri</span>
        <span className={light ? "text-ns-gold" : "text-ns-goldtext"}>Swaad</span>
      </span>
      <span className={`mt-0.5 block font-hindisans text-[12px] font-semibold leading-tight ${light ? "text-ns-gold" : "text-ns-bronze"}`}>
        स्वाद, सेहत और भरोसा भी
      </span>
    </span>
  </a>
);
